import {BaseService} from "@/service/BaseService.ts";

export class DeployService {
    static deployApplication = (others: any, appId: number) => {
        return BaseService.apiClient(others, false).get(`/${appId}`, {
            baseURL: import.meta.env.VITE_DEPLOY_BASE_URL,
        })
    }
}
